import _AlertWarningIcon from "@adsk/alloy-react-icon/es/lib/AlertWarningIcon";
import _styled from "styled-components";
import React from 'react';
import { LinkButton } from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
const DefaultError = _ref => {
  let {
    onRetry
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require(`../i18n/${locale}.json`);
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_AlertWarningIcon, {
    size: 20,
    style: {
      marginRight: theme.spacing.XS
    }
  }), /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css: [theme.typography.bodySmall, {
      marginRight: theme.spacing.XS
    }]
  }, T.translate('COULDNT_LOAD')), /*#__PURE__*/React.createElement(LinkButton, {
    "data-testid": "tryAgain",
    onClick: onRetry,
    size: LinkButton.SIZES.SMALL
  }, T.translate('TRY_AGAIN')));
};
export default DefaultError;
var _StyledSpan = _styled("span").withConfig({
  displayName: "DefaultError___StyledSpan",
  componentId: "sc-n6wj5q-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=DefaultError.js.map